<template>
  <ModalDefault header="y"
                modal_id="showDepartmentModal"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_718')"
                :footer="departments.department.name"
                :method="updateDepartment"
                icon="bx bx-sitemap mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="d-flex">
          <div class="file-upload-center cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block pt-2 px-2">
              <div class="col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_400') }} </label>
                <div class="input-group mb-4">
                  <input type="text" v-model="departments.department.name" class="input_forms form-control">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span @click.prevent="updateDepartment" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_120') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import $ from "jquery";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalEditDepartment",
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['channels', 'departments']),
    ...mapGetters([])
  },
  methods: {
    updateDepartment(){
      if(this.departments.department.name.length < 3) return;
      this.$store.dispatch('updateDepartment', this.departments.department)
      $('#showDepartmentModal').modal('hide')
    },
  }
}
</script>

<style scoped>

</style>
